<template>
    <v-card class="panelBlock map-widget" v-if="chapterList && chapterList.length > 0">
        <v-flex tag="h2">{{communityCommonConstant.REGIONAL_MAP_OF_CHAPTERS}}</v-flex>

        <v-flex class="ypoMap">
            <ypo-map :mapList="chapterList" :center-to="getCenterTo" />
        </v-flex>

        <v-flex text-xs-right>
            <v-btn class="primary_btn small transparent" data-qe-id="map-expanded-view"
                   @click="showMapPopup=true">
                {{appCommonConstants.VIEW_ALL}}
            </v-btn>
        </v-flex>
        <v-dialog v-model="showMapPopup" content-class="large" persistent>
            <v-card class="regionMapPopup">
                <v-flex tag="h2">
                    {{communityCommonConstant.REGIONAL_MAP_OF_CHAPTERS}}
                    <i class="fas fa-times" @click="showMapPopup=false" data-qe-id="exit-map-expanded-view"></i>
                </v-flex>
                <ypo-map :mapList="allChapterList" :center-to="getCenterTo" />
                <v-flex text-xs-center>
                    <img :src="communityCommonConstant.chapterTypeIconConstant.YPO_Chapter" width="20" class="map-legends">{{communityCommonConstant.regionChapters.YPO_Chapter}}
                    <img :src="communityCommonConstant.chapterTypeIconConstant.YPO_Gold_Chapter" width="20" class="map-legends">{{communityCommonConstant.regionChapters.YPO_Gold_Chapter}}
                    <img :src="communityCommonConstant.chapterTypeIconConstant.YPO_Integrated_Chapter" width="20" class="map-legends">{{communityCommonConstant.regionChapters.YPO_Integrated_Chapter}}
                </v-flex>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import { ypoMapConstant } from "../YpoMap/ypoMap.constant.js";
    import { appCommonConstants, routerNames } from '../appCommon.constants';
    import { communityCommonConstant, getParentOrCommunityId } from '@/components/ChapterPage/communityCommon.constant';
    import { mapGetters } from 'vuex';
    import { storeGetters } from '@/store/storeGetters.constant';
    import YpoMap from '../YpoMap/YPOMap';

    export default {
        name: "RegionMap",
        components: {
            YpoMap,
        },
        data() {
            return {
                routerNames,
                communityCommonConstant,
                ypoMapConstant,
                appCommonConstants,
                showMapPopup: false,
            };
        },
        computed: {
            ...mapGetters({
                allChapterList: `chapter/${storeGetters.allChapterList}`,
            }),
            communityId(){
                return getParentOrCommunityId(this.allChapterList, this.$route.params.communityId);
            },
            chapterList() {
                return this.allChapterList ?
                    this.allChapterList.filter(c => c.parentId === this.communityId && c.parentId.toLowerCase()
                        !== communityCommonConstant.GLOBAL_REGION_GUID) : [];
            },
            getCenterTo() {
                if (this.chapterList && this.chapterList.some(c => c.parentId === this.communityId && c.longitude && c.latitude)) {
                    const centerTo = this.chapterList.find(c => c.parentId === this.communityId && c.longitude && c.latitude);
                    return {
                        lat: centerTo.latitude,
                        lng: centerTo.longitude,
                    };
                }
                return {};
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/colors";

    .map-widget {
        .ypoMap {
            min-height: 250px;

        }
    }

    .regionMapPopup {
        h2 {
            position: relative;
            background: $ypo-cta;
            font-size: 14px;
            color: $white;
            padding: 12px 20px;
            font-family: Raleway;

            i {
                cursor: pointer;
                position: absolute;
                right: 15px;
                top: 15px;
            }
        }

    }

    .regionMapPopup {
        .vue-map-container {
            height: 460px;
        }
    }
</style>